<template>
  <div v-if="config.manager_reminders_available" class="m-tx1">
    <div class="f f-ac">
      <donut-input-checkbox
        :model-value="config.active && config.manager_reminders"
        label="Send private reminders to managers"
        :disabled="locked"
        @update:model-value="onChange"
      />
      <i v-tooltip="tooltip" class="mi md-16 m-lx1 dark-gray">info</i>
    </div>
    <div v-if="!config.managers_known && !config.manager_reminders" class="f-as m-tx1">
      <i class="mi md-18 warning-yellow m-t1 m-r">warning</i>
      <div class="t-sm warning-yellow w-400">
        No one on your team has a manager in Donut yet, so we can't send private reminders. Make sure your HRIS includes each person's manager.
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, dispatch } = useStore();

  const props = defineProps({
    milestoneType: { type: String, required: true },
  });

  const config = computed(() => state.bonusMilestoneConfigs[props.milestoneType]);
  const occasion = computed(() => (props.milestoneType === 'anniversary' ? 'work anniversary' : 'birthday'));
  const locked = computed(() => !config.value.active || (!config.value.managers_known && !config.value.manager_reminders));
  const tooltip = computed(() => `When checked, we'll DM managers a reminder 1 day before each recipient's ${occasion.value}. `
    + `This needs ${occasion.value} points turned on.`);

  const onChange = (value) => {
    dispatch('bonusMilestoneConfigs/updateMilestoneConfig', { type: props.milestoneType, params: { manager_reminders: value } })
      .then(() => { dispatch('setSuccessToast', `Manager reminders turned ${value ? 'on' : 'off'}.`); })
      .catch(() => { dispatch('setErrorToast', 'Failed to update manager reminders.'); });
  };
</script>
